<div
	[class]="
		cn('tag', colorClass(), clickable() && 'tag-border cursor-pointer')
	"
	(click)="onClick()"
	data-test-class="tag"
>
	@if (iconLeading()) {
		<svg-icon [src]="iconLeading()" class="size-3 grow-0" />
	}
	<ng-content />
	@if (iconTrailing()) {
		<svg-icon [src]="iconTrailing()" class="size-3 grow-0" />
	}
</div>
